export const phone = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\\s\\./0-9]*$/
export const basicPostalCode = /^[a-zA-Z0-9][a-zA-Z0-9\- ]{0,10}[a-zA-Z0-9]$/
export const twoDigitCountryCode = /^[A-Z]{2}$/
export const AWRS = /^([A-Z]{4}\d{11}|RETAIL|PRIVATE|UNDERBOND)$/
